import * as React from "react";
import { createLucideIcon, type LucideProps } from "lucide-react";

const LambdaIcon = createLucideIcon("Lambda", [
  [
    "path",
    {
      d: "M11.38 10 5 20",
      key: "path-0",
    },
  ],
  [
    "path",
    {
      d: "M19 18a2 2 0 0 1-2 2c-4.87-.003-5.052-16-10-16a2 2 0 0 0-2 2",
      key: "path-1",
    },
  ],
]) as any;

export const Lambda = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ className = "lucide-logo", viewBox = "0 0 24 24", ...props }, ref) =>
    React.createElement(LambdaIcon, {
      ref,
      className,
      viewBox,
      ...props,
    }),
) as any;

Lambda.displayName = "Lambda";
